import {FunctionComponent, TableHTMLAttributes} from 'react';
import {clsx} from 'clsx';
import {TABLE_THEME, TableTheme} from '@/constants/table';

type HeaderProps = TableHTMLAttributes<HTMLTableCellElement> & {
  headers: string[];
  theme: TableTheme;
};

const TableHeader: FunctionComponent<HeaderProps> = ({headers, theme}) => {
  const isPrimary = theme === TABLE_THEME.PRIMARY;
  const isSecondary = theme === TABLE_THEME.SECONDARY;

  return (
    <thead className="text-left text-base leading-5 text-charcoal">
      <tr>
        {headers.map((label, index) => (
          <th
            className={clsx(
              isPrimary && 'pb-2 font-normal',
              isSecondary && 'bg-grey-200 py-3 font-semibold text-gray-600 first:pl-3 last:pr-3',
            )}
            key={index}
          >
            {label}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
